// DO NOT EDIT, GENERATED BY "yarn sheets"

import type { LogoRow } from '../typings';

const data = [
  {
    "id": "Alabama",
    "name": "Alabama",
    "isDisabled": false,
    "props": {
      "colorCount": 0
    }
  },
  {
    "id": "Arizona",
    "name": "Arizona",
    "isDisabled": false,
    "props": {
      "colorCount": 0
    }
  },
  {
    "id": "Arkanzasas",
    "name": "Arkanzasas",
    "isDisabled": false,
    "props": {
      "colorCount": 0
    }
  },
  {
    "id": "CalStateFullerton",
    "name": "Cal State Fullerton",
    "isDisabled": false,
    "props": {
      "colorCount": 0
    }
  },
  {
    "id": "Houston",
    "name": "Houston",
    "isDisabled": false,
    "props": {
      "colorCount": 0
    }
  },
  {
    "id": "OleMiss",
    "name": "Ole Miss",
    "isDisabled": false,
    "props": {
      "colorCount": 0
    }
  },
  {
    "id": "SDSU",
    "name": "SDSU",
    "isDisabled": false,
    "props": {
      "colorCount": 0
    }
  },
  {
    "id": "SouthCarolina",
    "name": "South Carolina",
    "isDisabled": false,
    "props": {
      "colorCount": 0
    }
  },
  {
    "id": "TexasTech",
    "name": "Texas Tech",
    "isDisabled": false,
    "props": {
      "colorCount": 0
    }
  },
  {
    "id": "UCLA",
    "name": "UCLA",
    "isDisabled": false,
    "props": {
      "colorCount": 0
    }
  },
  {
    "id": "WesternMichigan",
    "name": "Western Michigan",
    "isDisabled": false,
    "props": {
      "colorCount": 0
    }
  }
] as const;

type Primitive = string | number | boolean | null | undefined;
type Immutable<T> = T extends Primitive
  ? T
  : { readonly [K in keyof T]: Immutable<T[K]> };

type Combine<T extends U, U> = T extends Readonly<Primitive | Primitive[]>
  ? T
  : T extends ReadonlyArray<infer I>
  ? Readonly<Combine<I, Extract<U, Readonly<any[]>>[number]>[]>
  : U extends Readonly<Primitive | any[]>
  ? never
  : string extends keyof U
  ? { [K in keyof T & string]: Combine<T[K], U[K]> }
  : number extends keyof U
  ? { [K in keyof T & number]: Combine<T[K], U[K]> }
  : symbol extends keyof U
  ? { [K in keyof T & symbol]: Combine<T[K], U[K]> }
  : { [K in keyof U]: Combine<T[K], U[K]> };

const typed: Combine<typeof data, Immutable<LogoRow[]>> = data;

export type Logo = typeof typed[number];

export const LOGO_INDEX_KEY = "id";
export type LogoIndexKey = "id";
export type LogoId = Logo["id"];

let i = 0;
export const LOGO_DICT = {
  "Alabama": typed[i++],
  "Arizona": typed[i++],
  "Arkanzasas": typed[i++],
  "CalStateFullerton": typed[i++],
  "Houston": typed[i++],
  "OleMiss": typed[i++],
  "SDSU": typed[i++],
  "SouthCarolina": typed[i++],
  "TexasTech": typed[i++],
  "UCLA": typed[i++],
  "WesternMichigan": typed[i++]
} as const;

export { typed as LOGOS };
